import React, { useState, useRef, useEffect, useContext } from "react";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Webcam from "react-webcam"; // Import react-webcam
import { User } from "react-feather"; // Import the User icon
import VisitorContext from "./VisitorContext";
import axios from "axios";
import CryptoJS from "crypto-js";
import { fetchVisitorTypesN } from "../../services/Api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import * as bodyPix from "@tensorflow-models/body-pix";
import Loader from "../../Loader/loader";
import { SelfieSegmentation } from "@mediapipe/selfie_segmentation";
import { axiosInstance } from "../../services/Api";
import { FaceDetection } from "@mediapipe/face_detection";
import SignatureCanvas from 'react-signature-canvas';

import "@tensorflow/tfjs";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Heading = styled.h1`
  font-size: 25px;
  font-family: "Segoe UI", Semibold;
  color: #2b3497;
  margin: 0;
  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

const Button = styled.button`
  width: 81px;
  height: 32px;
  border-radius: 7px;
  box-shadow: 0px 5px 10px #2b349754;
  color: white;
  font-size: 14px;
  border: none;
  cursor: pointer;
  font-family: "Segoe UI", Semibold;
`;

const ResetButton = styled(Button)`
  background-color: red;
`;

const SubmitButton = styled(Button)`
  background-color: #2b3497;
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 20px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Card = styled.div`
  flex: 1;
  background: #fff;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 27px;
  opacity: 1;
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;
const FormRow = styled.div`
  display: flex;
  gap: 20px; /* Adjust spacing between inputs */
  justify-content: space-between;
  width: 100%;
`;
const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  font-family: "Segoe UI", Semibold;
  color: #000;
  margin-bottom: 5px;
  font-weight: 600;
`;

const Asterisk = styled.span`
  color: red;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: "Segoe UI", Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: "Segoe UI", Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }
`;

const StyledDatePicker = styled(DatePicker)`
  width: 335px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: "Segoe UI", Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container {
    width: 100%;
  }

  .react-datepicker__input-container input {
    width: 100%;
    padding: 8px 0;
    border: none;
    font-family: "Segoe UI", Regular;
    background: transparent;
    border-bottom: 1px solid #2b3497;
    &:focus {
      outline: none;
      border-bottom: 2px solid #2b3497;
    }
  }
  @media (max-width: 2060px) and (min-width: 1920px) {
    width: 585px;
  }
  @media (max-width: 1920px) and (min-width: 1720px) {
    width: 545px;
  }
  @media (max-width: 1720px) and (min-width: 1420px) {
    width: 480px;
  }
  @media (max-width: 1420px) and (min-width: 1220px) {
    width: 400px;
  }
  @media (max-width: 1220px) and (min-width: 1020px) {
    width: 200px;
  }
  @media (max-width: 1020px) and (min-width: 980px) {
    width: 175px;
  }
`;

const ProfileCard = styled(Card)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Circle = styled.div`
  width: 131px;
  height: 131px;
  background: linear-gradient(#ffffff, #f6f6f6);
  border-radius: 50%;
  box-shadow: 0px 10px 10px #00000024;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
`;

const ProfileIcon = styled.div`
  width: 134px;
  height: 131px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2b3497;
  font-size: 30px;
  font-weight: bold;
  position: relative;
`;

const PlusIcon = styled.div`
  width: 47px;
  height: 23px;
  border-radius: 50%;
  position: absolute;
  right: 0;
  bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #bfbfbf;
  font-size: 44px;
  font-weight: 700;
`;

const ProfileText = styled.div`
  font-family: "Segoe UI", Semibold;
  font-size: 18px;
  color: #ff3030;
  margin-bottom: 20px;
  text-align: center;
`;
const VisitorPhotoHeading = styled.div`
  font-family: "Segoe UI", Semibold;
  font-size: 25px;
  font-weight: 700;
  color: #2b3497;
  text-align: center;
  margin-bottom: 10px;
`;

const PhotoButton = styled.button`
  width: 160px;
  height: 35px;
  background-color: #343d9b;
  box-shadow: 0px 10px 10px #2b349733;
  border: 2px solid #343d9b;
  border-radius: 8px;
  opacity: 1;
  color: #ffffff;
  cursor: pointer;
  margin-bottom: 20px;
`;

const ActionButton = styled.button`
  width: 160px;
  height: 35px;
  background-color: transparent;
  border: 2px solid #343d9b;
  border-radius: 8px;
  box-shadow: 0px 10px 10px #2b349733;
  opacity: 1;
  cursor: pointer;
  margin-bottom: 20px;
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  color: red;
  font-family: "Segoe UI", Semibold;
  font-size: 14px;
`;

const PrivacyLink = styled.a`
  color: #2b3497;
  margin-left: 5px;
  text-decoration: none;
  cursor: pointer;
`;
const WebcamContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  overflow: hidden;
`;
const ButtonRow = styled.div`
  display: flex;
  gap: 10px; /* Adjust gap between buttons */
  margin-bottom: 20px; /* Optional: Adjust margin bottom */
`;

const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const PopupContent = styled.div`
  background: white;
  width: 500px;
  max-height: 80%;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  overflow-y: auto;
  text-align: left;
  /* Scrollbar styling */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #293495; /* Custom scrollbar thumb color */
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #ff3030; /* Hover color */
  }

  /* Firefox scrollbar */
  scrollbar-color: #293495 #f1f1f1;
  scrollbar-width: thin;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center; /* Center the button horizontally */
  margin-top: 20px;
`;

const CloseButton = styled.button`
  background-color: #293495;
  color: white;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #ff3030;
  }
`;

// Tabs container
const Tabs = styled.div`
  display: flex;
  border-bottom: 2px solid #ccc;
  margin-bottom: 20px;
`;

const Tab = styled.button`
  background: none;
  border: none;
  font-family: "Segoe UI", Semibold;
  padding: 10px 20px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  color: #000;
  &:hover {
    color: #2b3497;
  }
  ${({ active }) =>
    active &&
    `
    border-bottom: 2px solid #2B3497;
    color: #2B3497;
  `}
  ${({ disabled }) =>
    disabled &&
    `
  cursor:not-allowed;
  opacity: 0.5
  `}
`;

const TabContent = styled.div`
  display: ${({ active }) => (active ? "block" : "none")};
`;

//css file acknowlaged
const AckItem = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 20px 12px;
  margin-bottom: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fafafa;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #f0f4ff;
  }

  input {
    margin-top: 3px;
    cursor: pointer;
  }
`;

const AckText = styled.span`
  font-size: 14px;
  color: #333;
  line-height: 1.4;

  a {
    color: #293495;
    font-weight: 500;
    text-decoration: underline;
  }
`;

const TableContainer = styled.div`
  margin-top: 20px;
  width: 100%;
  overflow-x: auto; /* makes it scrollable horizontally */
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(
    to right,
    #e6e6e6,
    #f2f2f2,
    #f5f5f5,
    #f3f3f3,
    #e9e9e9
  );
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 9px 10px;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }

  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
  font-size: 13px;
`;

const PdfModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
`;

const PdfModalContent = styled.div`
  background: #fff;
  padding: 20px;
  width: 80%;
  max-width: 900px;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #0000001a;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const CloseButtonIcon = styled.button`
  position: absolute;
  top: 4px;
  right: 15px;
  border: none;
  background: transparent;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  color: #293495;
`;

const PdfFrame = styled.iframe`
  width: 100%;
  height: 80vh;
  border: none;
  margin-top: 10px;
`;

const SignAndAgreeContainer = styled.div`
display: flex;
justify-content: flex-end;
`;

const AgreeButton = styled.button`
  margin-top: 15px;
  margin-right: 10px;
  align-self: flex-end;
  padding: 10px 18px;
  background: #293495;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s ease;

  &:hover {
    background: #1f276f;
  }
`;

const FileUploadContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const HiddenFileInput = styled.input`
  display: none;
`;

const CustomFileButton = styled.button`
  background-color: #293495;
  color: #ffffff;
  padding: 8px 16px;
  font-size: 14px;
  font-family: "Segoe UI", Semibold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background-color: #1f2875;
  }
`;

const FileNameInput = styled.input`
  flex: 1;
  padding: 8px;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: "Segoe UI", Regular;
  background: transparent;
  color: #000;

  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }
`;

const VisitorApplication = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook
  const location = useLocation(); // Initialize useNavigate hook
  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const sigCanvasRef = useRef(null);

  const [visitormobile, setVisitorMobile] = useState(null);
  const [username, setUsername] = useState(null); // State to hold the username
  const [visitorTypes, setVisitorTypes] = useState([]);
  const [mailData, setMailData] = useState(null);
  const [managerMail, setManagerMail] = useState("");
  const [managerName, setManagerName] = useState("");
  const [employeeMail, setEmployeeMail] = useState("");
  const { decryptedAppId, hostName } = location.state || {};
  const [appointmentData, setAppointmentData] = useState("");
  const [isChecked, setIsChecked] = useState(false); // Add state to track checkbox
  const [loading, setLoading] = useState(false); // Global loading state
  const [fieldDataLoaded, setFieldDataLoaded] = useState(false);
  const [ndaSignature, setNDASignature] = useState(""); 

  console.log("appointmentData", appointmentData);

  useEffect(() => {
    const getVisitorTypes = async () => {
      const empNameID = localStorage.getItem("OTPEMPID");
      try {
        const types = await axiosInstance.get(
          `/VisitorType/GetVisitorTypeDetailsByEmpId/${empNameID}`,
        );
        setVisitorTypes(types.data);
      } catch (error) {
        console.error("Error fetching visitor types:", error);
      }
    };
    getVisitorTypes();
  }, []);

  const [selectedIdProofType, setSelectedIdProofType] = useState("");

  const [idProofTypes, setIdProofTypes] = useState([]);

  const [formData, setFormData] = useState({
    // visitorName: '',
    firstName: "",
    middleName: "",
    lastName: "",
    visitorEmail: "",
    visitorMobile: "",
    gender: "",
    nationality: "",
    visitorType: "",
    visitorCompany: "",
    meetingOn: null,
    meetingTo: null,
    visitorPhoto: "",
    visitorTypeDesc: "",
    idProofId: selectedIdProofType || 0,
    visitorIdNumber: "",
  });

  const [formErrors, setFormErrors] = useState({
    // visitorName: false,
    firstName: false,
    lastName: false,
    visitorEmail: false,
    visitorMobile: false,
    visitorCompany: false,
  });

  const [appId, setAppId] = useState(null);
  const [employeeName, setEmployeeName] = useState("");
  const [employeeId, setEmployeeId] = useState("");

  useEffect(() => {
    if (decryptedAppId) {
      //  console.log('Decrypted appId:', decryptedAppId);
      // Fetch appointment data
      const fetchAppointmentData = async (id) => {
        try {
          const response = await axiosInstance.get(`/Appointment/${id}`);
          if (response.status === 200) {
            // console.log('Appointment data fetched:', response.data);
            setAppointmentData(response.data);
            const empData = response.data;
            // console.log('empData', empData);

            if (empData[0].employeeId) {
              fetchManagerMail(empData[0].employeeId);
            }
          } else {
            console.error("Failed to fetch appointment data");
          }
        } catch (error) {
          console.error("Error fetching appointment data:", error);
        }
      };
      fetchAppointmentData(decryptedAppId);
      const getIdProofTypes = async () => {
        try {
          const types = await axiosInstance.get("/idproof");
          setIdProofTypes(types.data);
        } catch (error) {
          console.error("Error fetching visitor types:", error);
        }
      };
      getIdProofTypes();
    }
  }, [decryptedAppId]);
  const [fieldData, setFieldData] = useState("");

  useEffect(() => {
    if (
      appointmentData &&
      appointmentData.length > 0 &&
      visitorTypes &&
      visitorTypes.length > 0
    ) {
      const visitorTy = visitorTypes.find(
        (type) => type.id === appointmentData[0].selectedVisitorTypeId,
      );

      setFieldData(visitorTy?.individualAppointmentInputField?.[0] || {});

      setFormData((prevData) => ({
        ...prevData,
        firstName: appointmentData[0].firstName || "",
        middleName: appointmentData[0].middleName || "",
        lastName: appointmentData[0].lastName || "",
        visitorEmail: appointmentData[0].visitorEmail || "",
        gender: appointmentData[0].gender || "",
        nationality: appointmentData[0].nationality || "",
        visitorMobile: appointmentData[0].visitorMobile || "",
        visitorType: appointmentData[0].selectedVisitorTypeId || "",
        visitorTypeDesc: visitorTy?.visitorTypeDesc || "",
        meetingTo: appointmentData[0].meetingTo || null,
        meetingOn: appointmentData[0].meetingOn || null,
        employeeId: appointmentData[0].employeeId,
        idProofId: appointmentData[0].idProofId,
        visitorIdNumber: appointmentData[0].visitorIdNumber,
      }));
    }
  }, [appointmentData, visitorTypes]);

  const handleResetAcknowledgement = () => {
    setAckChecklist((prev) =>
      Object.fromEntries(Object.keys(prev).map((key) => [key, false])),
    );
  };

  const handleReset = () => {
    setIsChecked(false);
    setProfileImage("");
    setFormData((prevFormData) => ({
      ...prevFormData, // Spread the existing state to retain other fields
      visitorPhoto: "",
      visitorCompany: "",
      vehicleno: "",
    }));

    setFormErrors({
      visitorCompany: false,
    });
    // console.log('Form reset');
  };
  const handleSelectChange = (e) => {
    const selectedId = e.target.value;
    const selectedType = visitorTypes.find(
      (type) => type.id === parseInt(selectedId),
    );

    setFormData((prevState) => ({
      ...prevState,
      visitorType: selectedId,
      visitorTypeDesc: selectedType ? selectedType.visitorTypeDesc : "",
    }));
  };
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleNext = async (event) => {
    let valid = true;
    const errors = {};

    if (!appointmentData[0]?.entityId) {
      toast.error("Entity ID is missing");
      return;
    }
    if (fieldData?.visitorNameField && formData.firstName === "") {
      errors.firstName = true;
      valid = false;
    }
    if (fieldData?.visitorNameField && formData.lastName === "") {
      errors.lastName = true;
      valid = false;
    }
    if (fieldData?.visitorEmailField && formData.visitorEmail === "") {
      errors.visitorEmail = true;
      valid = false;
    }
    if (fieldData?.visitorMobileField && formData.visitorMobile === "") {
      errors.visitorMobile = true;
      valid = false;
    }
    if (fieldData?.genderField && formData.gender === "") {
      errors.gender = true;
      valid = false;
    }
    if (fieldData?.nationalityField && formData.nationality === "") {
      errors.nationality = true;
      valid = false;
    }
    if (formData.visitorCompany === "") {
      errors.visitorCompany = true;
      valid = false;
    }
    if (fieldData?.idProofTypeField && formData.idProofId === "") {
      errors.idProofId = true;
      valid = false;
    }
    if (fieldData?.idProofNumberField && formData.visitorIdNumber === "") {
      errors.visitorIdNumber = true;
      valid = false;
    }

    if (formData.visitorEmail !== "") {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(formData.visitorEmail)) {
        errors.visitorEmail = true;
        valid = false;
      }
    }

    // if (formData.visitorMobile !== '') {
    //     const mobilePattern = /^\d{10}$/;
    //     if (!mobilePattern.test(formData.visitorMobile)) {
    //         errors.visitorMobile = true;
    //         valid = false;
    //     }
    // }

    if (!valid) {
      setFormErrors(errors);
      //  console.log('Form has errors:', errors);
      setLoading(false); // Show loader on POST requests
      setActiveTab("details");
      return;
    }
    if (formData.visitorPhoto == "") {
      toast.error("Photo is not captured, Please upload the photo ");
      setActiveTab("details");
      return;
    } else {
      if (!isChecked) {
        toast.error("Please verify the privacy ");
        setActiveTab("details");
        return;
      } else {
        setDetailsValid("true");
        setActiveTab("acknowledge");
      }
    }
  };

  const messages = {
    training: "Please agree to the Training Video acknowledgment.",
    safetyVideo: "Please agree to the Safety Video acknowledgment.",
    safetyDoc: "Please agree to the Safety Document acknowledgment.",
    ndaDoc: "Please agree to the NDA Document.",
  };

  const handleSubmit = async () => {
    let valid = true;
    const errors = {};

    if (!appointmentData[0]?.entityId) {
      toast.error("Entity ID is missing");
      return;
    }
    if (fieldData?.visitorNameField && formData.firstName === "") {
      errors.firstName = true;
      valid = false;
    }
    if (fieldData?.visitorNameField && formData.lastName === "") {
      errors.lastName = true;
      valid = false;
    }
    if (fieldData?.visitorEmailField && formData.visitorEmail === "") {
      errors.visitorEmail = true;
      valid = false;
    }
    if (fieldData?.visitorMobileField && formData.visitorMobile === "") {
      errors.visitorMobile = true;
      valid = false;
    }
    if (fieldData?.genderField && formData.gender === "") {
      errors.gender = true;
      valid = false;
    }
    if (fieldData?.nationalityField && formData.nationality === "") {
      errors.nationality = true;
      valid = false;
    }
    if (formData.visitorCompany === "") {
      errors.visitorCompany = true;
      valid = false;
    }
    if (fieldData?.idProofTypeField && formData.idProofId === "") {
      errors.idProofId = true;
      valid = false;
    }
    if (fieldData?.idProofNumberField && formData.visitorIdNumber === "") {
      errors.visitorIdNumber = true;
      valid = false;
    }

    if (formData.visitorEmail !== "") {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(formData.visitorEmail)) {
        errors.visitorEmail = true;
        valid = false;
      }
    }

    // if (formData.visitorMobile !== '') {
    //     const mobilePattern = /^\d{10}$/;
    //     if (!mobilePattern.test(formData.visitorMobile)) {
    //         errors.visitorMobile = true;
    //         valid = false;
    //     }
    // }
    if (formData.visitorPhoto == "") {
      toast.error("Photo is not captured, Please upload the photo ");
      setActiveTab("details");
      return;
    }

    for (const key in ackChecklist) {
      console.log("key value", key);
      if (ackChecklist[key] === false) {
        setActiveTab("acknowledge");
        toast.error(messages[key]);
        return;
      }
    }

    if (!valid) {
      setFormErrors(errors);
      //  console.log('Form has errors:', errors);
      setLoading(false); // Show loader on POST requests
      setActiveTab("details");
      return;
    } else {
      if (!isChecked) {
        toast.error("Please verify the privacy ");
        setActiveTab("details");
        return;
      } else {
        try {
          setLoading(true); // Show loader on POST requests

          const data = {
            ...formData,
            Id: appointmentData[0].id,
            visitorName: formData.firstName,
            selectedVisitorTypeId: appointmentData[0].selectedVisitorTypeId,
            IsCoupon: 3, // Ensure the hard-coded value is included
            NDASignature: ndaSignature,
          };

          const response = await axiosInstance.put(
            "/Appointment/AppointmentUpdated",
            data,
            {
              headers: {
                "Content-Type": "application/json",
              },
            },
          );

          if (response.status === 200) {
            toast.success("Successfully Updated!");
            // console.log('Appointment updated successfully:', response.data);
            // Call sendEmail with the updated appointment data
            // await sendEmail(appointmentData);
            setIsSubmitted(true);

            navigate("/form-submitted");
            // Store the appointment data from the response
            // setMailData(response.data);
          } else {
            console.error("Failed to update appointment");
          }
        } catch (error) {
          console.error("Error updating appointment:", error);
        } finally {
          setLoading(false); // Hide loader after API call
        }
      }
    }
  };

  const [empName, setEmpName] = useState("");

  const fetchManagerMail = async (id) => {
    try {
      const response = await axiosInstance.get(`/Employee/${id}`);
      // console.log('response', response);
      setEmployeeMail(response.data.employeeMailId);
      setEmpName(response.data.employeeName);
      // Assuming API returns empMail property

      setManagerMail(response.data.managerMailID); // Assuming API returns empMail property
      // console.log('managerMailID', response.data.managerMailID);
      const managerMailId = response.data.managerMailID;

      // if (managerMailId) {
      //     fetchManagerName(managerMailId);
      // }
    } catch (error) {
      console.error("Error fetching fetchManagerMail:", error);
    }
  };

  // const fetchManagerName = async (empEmail) => {
  //     try {
  //         const response = await axiosInstance.get(`/Employee/EmployeeMail/${empEmail}`);
  //         setManagerName(response.data.employeeName); // Assuming API returns empMail property

  //         console.log('ManagerName', response.data.employeeName);

  //     } catch (error) {
  //         console.error('Error fetching employee employeeName:', error);
  //     }
  // };

  // const sendEmail = async (appointmentData) => {
  //     try {
  //         if (!appointmentData || !appointmentData[0]) {
  //             console.error('Invalid appointment data:', appointmentData);
  //             return;
  //         }
  //         // Convert meetingTo to the required format
  //         const validTillDate = new Date(appointmentData[0].meetingTo);
  //         const validTillFormatted = validTillDate.toISOString();

  //         const model = {
  //             mailType: "MAILTOVISITORBYSEC",
  //             mailSubject: `Info : Your ePass to visit Fidrox ${appointmentData[0].meetingvenue}`,
  //             toAddress: appointmentData[0].visitorEmail,
  //             docId: appointmentData[0].id,
  //             employeeMailId: employeeMail,
  //             visitorMobile: appointmentData[0].visitorMobile,
  //             hostName: hostName,
  //             meetingOn: appointmentData[0].meetingOn,// Assuming MeetingOn is a date or datetime
  //             visitorType: formData.visitorTypeDesc, // Use visitorTypeDesc here
  //             visitorPhoto: formData.visitorPhoto,
  //             //visitorPhoto:'',
  //             Gate: appointmentData[0].gate,
  //             Building: appointmentData[0].building,
  //             visitorCompany: formData.visitorCompany,
  //             visitorName: appointmentData[0].visitorName,
  //             meetingVenue: appointmentData[0].meetingvenue,
  //             managerName: managerName,
  //             managerMail: managerMail, // Use managerMail from state
  //             visitorEmail: appointmentData[0].visitorEmail,
  //             meetingTo: appointmentData[0].meetingTo,
  //             purpose: appointmentData[0].purpose,
  //             validTill: validTillFormatted,
  //             foodCoupon: '',
  //             txtManagersID: '',
  //             secsEmailId: '',
  //             duration: '',
  //             link: '',
  //             rejectionNotes: '',
  //             securityMail: '',
  //             securityName: '',
  //             qrCode: '',

  //         };
  //         console.log('appointmentData[0].visitorEmail', appointmentData[0].visitorEmail);

  //         const response = await axiosInstance.post('/Mail', model, {
  //             headers: {
  //                 'Content-Type': 'application/json',
  //             },
  //         });

  //         if (response.status === 200) {
  //             console.log('Email sent successfully:', response.data);
  //         } else {
  //             console.error('Failed to send email');
  //         }

  //     } catch (error) {
  //         console.error('Error sending email:', error);
  //     }

  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: false,
    }));
  };

  const webcamRef = useRef(null);
  const [isCameraOn, setIsCameraOn] = useState(false);
  const [buttonLabel, setButtonLabel] = useState("Take photo");
  const [profileImage, setProfileImage] = useState(null);

  const resizeAndCompress = async (canvas) => {
    const targetWidth = 320; // Reduce width
    const targetHeight = 240; // Reduce height

    const resizedCanvas = document.createElement("canvas");
    resizedCanvas.width = targetWidth;
    resizedCanvas.height = targetHeight;

    const resizedCtx = resizedCanvas.getContext("2d");
    resizedCtx.drawImage(canvas, 0, 0, targetWidth, targetHeight);

    // Lower quality to reduce base64 size
    return resizedCanvas.toDataURL("image/jpeg", 0.3); // JPEG format, 30% quality
  };

  const processImageWithSegmentation = async (image) => {
    const canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(image, 0, 0, image.width, image.height);

    const segmentation = new SelfieSegmentation({
      locateFile: (file) =>
        `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`,
    });

    segmentation.setOptions({ modelSelection: 1 });
    await segmentation.initialize();

    const results = await new Promise((resolve) => {
      segmentation.onResults(resolve);
      segmentation.send({ image });
    });

    const outputCanvas = document.createElement("canvas");
    outputCanvas.width = image.width;
    outputCanvas.height = image.height;
    const outputCtx = outputCanvas.getContext("2d");

    // Draw the original image
    outputCtx.drawImage(image, 0, 0, image.width, image.height);

    // Apply segmentation mask to retain only face
    outputCtx.globalCompositeOperation = "destination-in";
    outputCtx.drawImage(results.segmentationMask, 0, 0);

    // Fill background with white instead of transparent
    outputCtx.globalCompositeOperation = "destination-over";
    outputCtx.fillStyle = "#fff"; // WHITE background
    outputCtx.fillRect(0, 0, image.width, image.height);

    // Resize and compress
    return resizeAndCompress(outputCanvas);
  };

  const handleCapture = async () => {
    if (!isCameraOn) {
      setIsCameraOn(true);
      setButtonLabel("Capture");
    } else {
      const imageSrc = webcamRef.current.getScreenshot();
      if (!imageSrc) return;

      const img = new Image();
      img.src = imageSrc;

      img.onload = async () => {
        // Draw image to canvas for compatibility
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, img.width, img.height);

        // Convert to ImageBitmap for MediaPipe
        const imageBitmap = await createImageBitmap(canvas);

        // ✅ Correct faceDetection setup
        const faceDetection = new FaceDetection({
          locateFile: (file) =>
            `https://cdn.jsdelivr.net/npm/@mediapipe/face_detection/${file}`,
        });

        faceDetection.setOptions({
          model: "short", // fast + accurate model
          minDetectionConfidence: 0.5,
        });

        await faceDetection.initialize();

        // Run face detection
        const detectionResults = await new Promise((resolve) => {
          faceDetection.onResults(resolve);
          faceDetection.send({ image: imageBitmap });
        });

        // Check if face is detected
        if (
          !detectionResults.detections ||
          detectionResults.detections.length === 0
        ) {
          toast.error("Human face not detected");
          setIsCameraOn(false);
          setButtonLabel("Take photo");
          return;
        }

        // ✅ Face detected — continue with segmentation
        const base64Image = await processImageWithSegmentation(img);
        setProfileImage(base64Image);
        setFormData((prev) => ({
          ...prev,
          visitorPhoto: base64Image.split(",")[1],
        }));

        setIsCameraOn(false);
        setButtonLabel("Take photo");
      };
    }
  };

  const fileInputRef = useRef(null); // Add this line at the top

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file || (file.type !== "image/png" && file.type !== "image/jpeg")) {
      toast.error("Please upload a PNG or JPEG image");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = async () => {
      const img = new Image();
      img.src = reader.result;

      img.onload = async () => {
        const base64Image = await processImageWithSegmentation(img);
        setProfileImage(base64Image);

        setFormData((prev) => ({
          ...prev,
          visitorPhoto: base64Image.split(",")[1],
        }));

        setIsCameraOn(false); // ✅ turn off camera view if it's still on
        setButtonLabel("Take photo");
      };
    };

    reader.readAsDataURL(file);

    // ✅ Reset the input value so uploading the same image again still triggers onChange
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  // const handleCapture = async () => {
  //   if (!isCameraOn) {
  //     // Turn on the camera
  //     setIsCameraOn(true);
  //     setButtonLabel("Capture");
  //   } else {
  //     // Capture the webcam image
  //     const imageSrc = webcamRef.current.getScreenshot();
  //     console.log("Captured Image:", imageSrc);

  //     if (imageSrc) {
  //       // Create an image element from the captured image
  //       const img = new Image();
  //       img.src = imageSrc;

  //       img.onload = async () => {
  //         // Create a canvas for image processing
  //         const canvas = document.createElement("canvas");
  //         canvas.width = img.width;
  //         canvas.height = img.height;
  //         const ctx = canvas.getContext("2d");

  //         // Draw the captured image on the canvas
  //         ctx.drawImage(img, 0, 0, img.width, img.height);

  //         // Initialize MediaPipe Selfie Segmentation
  //         const segmentation = new SelfieSegmentation({
  //           locateFile: (file) =>
  //             `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`,
  //         });

  //         segmentation.setOptions({
  //           modelSelection: 1, // General-purpose face segmentation model
  //         });

  //         // Perform segmentation
  //         await segmentation.initialize();
  //         const results = await new Promise((resolve) => {
  //           segmentation.onResults(resolve);
  //           segmentation.send({ image: img });
  //         });

  //         // Create a canvas for output
  //         const outputCanvas = document.createElement("canvas");
  //         outputCanvas.width = img.width;
  //         outputCanvas.height = img.height;
  //         const outputCtx = outputCanvas.getContext("2d");

  //         // Draw the original image
  //         outputCtx.drawImage(img, 0, 0, img.width, img.height);

  //         // Apply the segmentation mask
  //         outputCtx.globalCompositeOperation = "destination-in"; // Retain only the face
  //         outputCtx.drawImage(
  //           results.segmentationMask,
  //           0,
  //           0,
  //           img.width,
  //           img.height
  //         );

  //         // Reset the operation and apply a transparent background
  //         outputCtx.globalCompositeOperation = "destination-over";
  //         outputCtx.fillStyle = "transparent"; // Transparent background
  //         outputCtx.fillRect(0, 0, img.width, img.height);

  //         // Convert the processed image to Base64
  //         const base64Image = outputCanvas.toDataURL("image/png");

  //         // Set the profile image and form data
  //         setProfileImage(base64Image); // Display the processed image
  //         setFormData((prevData) => ({
  //           ...prevData,
  //           visitorPhoto: base64Image.split(",")[1], // Store Base64 (excluding metadata)
  //         }));

  //         console.log("Processed Image (Base64):", base64Image);
  //       };
  //     }

  //     // Turn off the camera and reset the button label
  //     setIsCameraOn(false);
  //     setButtonLabel("Take photo");
  //   }
  // };

  // // Function to handle image upload from the file input
  // const handleImageUpload = async (e) => {
  //   const file = e.target.files[0]; // Get the uploaded file
  //   if (!file) return;

  //   const reader = new FileReader();
  //   reader.onloadend = async () => {
  //     const img = new Image();
  //     img.src = reader.result;

  //     img.onload = async () => {
  //       // Create a canvas for image processing
  //       const canvas = document.createElement("canvas");
  //       canvas.width = img.width;
  //       canvas.height = img.height;
  //       const ctx = canvas.getContext("2d");

  //       // Draw the uploaded image on the canvas
  //       ctx.drawImage(img, 0, 0, img.width, img.height);

  //       // Initialize MediaPipe Selfie Segmentation
  //       const segmentation = new SelfieSegmentation({
  //         locateFile: (file) =>
  //           `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`,
  //       });

  //       segmentation.setOptions({
  //         modelSelection: 1, // General-purpose face segmentation model
  //       });

  //       // Perform segmentation
  //       await segmentation.initialize();
  //       const results = await new Promise((resolve) => {
  //         segmentation.onResults(resolve);
  //         segmentation.send({ image: img });
  //       });

  //       // Create a canvas for output
  //       const outputCanvas = document.createElement("canvas");
  //       outputCanvas.width = img.width;
  //       outputCanvas.height = img.height;
  //       const outputCtx = outputCanvas.getContext("2d");

  //       // Draw the original image
  //       outputCtx.drawImage(img, 0, 0, img.width, img.height);

  //       // Apply the segmentation mask
  //       outputCtx.globalCompositeOperation = "destination-in"; // Retain only the face
  //       outputCtx.drawImage(
  //         results.segmentationMask,
  //         0,
  //         0,
  //         img.width,
  //         img.height
  //       );

  //       // Reset the operation and apply a transparent background
  //       outputCtx.globalCompositeOperation = "destination-over";
  //       outputCtx.fillStyle = "transparent"; // Transparent background
  //       outputCtx.fillRect(0, 0, img.width, img.height);

  //       // Convert the processed image to Base64
  //       const base64Image = outputCanvas.toDataURL("image/png");

  //       // Update the processed image in state and form data
  //       setProfileImage(base64Image); // Display the processed image
  //       setFormData({ ...formData, visitorPhoto: base64Image.split(",")[1] });
  //       console.log("base64Image", base64Image.split(",")[1]);
  //       // Save Base64 (excluding metadata)
  //     };
  //   };

  //   reader.readAsDataURL(file); // Read the file as base64
  // };

  const [isPopupVisible, setPopupVisible] = useState(false);

  const handlePrivacyLinkClick = () => {
    setPopupVisible(true);
  };

  const handleClosePopup = () => {
    setPopupVisible(false);
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: false,
      });
    }
  };

  const [transportVendorFileName, setTransportVendorFileName] = useState("");
  const [transportVendorFileBase64, setTransportVendorFileBase64] =
    useState("");

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) {
        resolve(null);
        return;
      }

      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(",")[1]); // remove "data:...base64,"
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const [activeTab, setActiveTab] = useState("details"); // State for tab management

  //acknowladge feature
  const [entity, setEntity] = useState([]); // Properly initialized as an empty array
  const [ackChecklist, setAckChecklist] = useState({});

  const [detailsValid, setDetailsValid] = useState(false); // controls Acknowledge tab enable
  const [openVideoModal, setOpenVideoModal] = useState(false);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [passACKData, setPassACKData] = useState("");
  const empId = localStorage.getItem("employeeId");
  const [pdfUrl, setPdfUrl] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [openPdfModal, setOpenPdfModal] = useState(false);
  const [agreedRows, setAgreedRows] = useState({});

  useEffect(() => {
    if (!appointmentData || appointmentData.length === 0) return;
    const fetchAppointmentDataeempEntity = async () => {
      const entityId = appointmentData?.[0]?.entityId;
      if (!entityId) {
        toast.error("Entity ID is missing");
        return;
      }

      try {
        const responseEntity = await axiosInstance.get(
          `/Entity/GetEntityByID/${entityId}`,
        );
        console.log("response", responseEntity?.data);
        const selectedEntity = responseEntity?.data;

        // If you want to keep it in state for modal usage:
        setEntity(responseEntity?.data);

        // Dynamically build the checklist based on what exists in the entity
        const initialChecklist = {};

        if (
          selectedEntity?.uploadTrainingVideos &&
          selectedEntity?.trainingVideosLink
        )
          initialChecklist.training = false;

        if (
          selectedEntity?.uploadSafetyGuidelinesDocuments &&
          selectedEntity?.safetyGuidelines?.safetyGuidelinesDocumentLink
        )
          initialChecklist.safetyDoc = false;

        if (
          selectedEntity?.uploadSafetyGuidelinesDocuments &&
          selectedEntity?.safetyGuidelines?.safetyGuidelinesVideoLink
        )
          initialChecklist.safetyVideo = false;

        if (selectedEntity?.ndaDocument) initialChecklist.ndaDoc = false;

        // Set it in state
        setAckChecklist(initialChecklist);
      } catch (error) {
        console.error("Error fetching appointment data:", error);
      }
    };
    fetchAppointmentDataeempEntity();
  }, [appointmentData]);

  return (
    <Container>
      {loading && <Loader />}

      <Header>
        <Heading>Visitor Application Form</Heading>
        <ButtonGroup>
          {activeTab == "details" ? (
            <ResetButton onClick={handleReset}>Reset</ResetButton>
          ) : (
            <ResetButton onClick={handleResetAcknowledgement}>
              Reset
            </ResetButton>
          )}
          {activeTab == "details" ? (
            <SubmitButton onClick={handleNext}>Next</SubmitButton>
          ) : (
            <SubmitButton
              onClick={handleSubmit}
              disabled={isSubmitted || loading}
            >
              {loading ? "Submitting" : "Submit"}
            </SubmitButton>
          )}
        </ButtonGroup>
      </Header>
      <Tabs>
        <Tab
          active={activeTab === "details"}
          onClick={() => setActiveTab("details")}
        >
          Details
        </Tab>
        <Tab
          active={activeTab === "acknowledge"}
          disabled={!detailsValid} // disable until details are valid
          onClick={() => setActiveTab("acknowledge")}
        >
          Acknowledgement
        </Tab>
      </Tabs>
      <TabContent active={activeTab === "details"}>
        <CardContainer>
          <Card>
            <FormRow>
              <FormGroup>
                <Label>
                  First Name
                  {fieldData?.visitorNameField && <Asterisk> *</Asterisk>}
                </Label>
                <Input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  placeholder="Enter first name"
                  style={{
                    borderBottomColor: formErrors.firstName ? "red" : "#2b3497",
                    opacity: formData.firstName ? 1 : 0.5, // Adjust opacity based on condition
                  }}
                  disabled={!fieldDataLoaded || fieldData?.visitorNameField} // Disable input based on condition
                />
              </FormGroup>

              <FormGroup>
                <Label>Middle Name</Label>
                <Input
                  type="text"
                  name="middleName"
                  value={formData.middleName}
                  onChange={handleInputChange}
                  placeholder="Enter Middle Name"
                />
              </FormGroup>

              <FormGroup>
                <Label>
                  Last Name
                  {fieldData?.visitorNameField && <Asterisk> *</Asterisk>}
                </Label>
                <Input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  placeholder="Enter last name"
                  disabled={!fieldDataLoaded || fieldData?.visitorNameField} // Disable input based on condition
                />
              </FormGroup>
            </FormRow>
            <FormGroup>
              <Label>
                Visitor Email
                {fieldData?.visitorEmailField && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="email"
                name="visitorEmail"
                value={formData.visitorEmail}
                placeholder="Enter Email"
                onChange={handleInputChange}
                style={{
                  borderBottomColor: formErrors.visitorEmail
                    ? "red"
                    : "#2b3497",
                  opacity: formData.visitorEmail ? 1 : 0.5, // Adjust opacity based on condition
                }}
                disabled={!fieldDataLoaded || fieldData?.visitorEmailField} // Disable input based on condition
              />
            </FormGroup>
            <FormGroup>
              <Label>
                Gender
                {fieldData?.genderField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="gender"
                value={formData.gender}
                onChange={handleInputChange}
                disabled={!fieldDataLoaded || fieldData?.genderField} // Disable input based on condition
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="other">Other</option>
              </Select>
              {formErrors.gender && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a gender
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Nationality
                {fieldData?.nationalityField && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="text"
                name="nationality"
                value={formData.nationality}
                onChange={handleInputChange}
                placeholder="Enter visitor name"
                style={{
                  borderBottomColor: formErrors.nationality ? "red" : "#2b3497",
                  opacity: formData.nationality ? 1 : 0.5, // Adjust opacity based on condition
                }}
                disabled={!fieldDataLoaded || fieldData?.nationalityField} // Disable input based on condition
              />
            </FormGroup>
            <FormGroup>
              <Label>
                Visitor Mobile
                {fieldData?.visitorMobileField && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="tel"
                name="visitorMobile"
                value={formData.visitorMobile}
                placeholder="Enter Mobile number"
                onChange={handleInputChange}
                style={{
                  borderBottomColor: formErrors.visitorMobile
                    ? "red"
                    : "#2b3497",
                  opacity: formData.visitorMobile ? 1 : 0.5, // Adjust opacity based on condition
                }}
                disabled={!fieldDataLoaded || fieldData?.visitorMobileField} // Disable input based on condition
              />
            </FormGroup>
            <FormGroup>
              <Label>
                Visitor Type <Asterisk> *</Asterisk>
              </Label>
              <Select
                name="visitorType"
                value={formData.visitorType}
                onChange={handleSelectChange}
                disabled={!fieldDataLoaded || fieldData?.visitorTypeField} // Disable input based on condition
              >
                <option value="">Select type</option>
                {visitorTypes.map((type) => (
                  <option
                    key={type.id}
                    value={type.id}
                    selected={type.id === formData.visitorType} // Set pre-selection
                  >
                    {type.visitorTypeDesc}
                  </option>
                ))}
              </Select>
            </FormGroup>
            <FormGroup>
              <Label>
                Visitor Company<Asterisk> *</Asterisk>
              </Label>
              <Input
                type="text"
                name="visitorCompany"
                placeholder="Enter Visitor Company"
                value={formData.visitorCompany}
                onChange={handleInputChange}
                style={{
                  borderColor: formErrors.visitorName ? "red" : "#2B3497",
                }}
              />
              {formErrors.visitorCompany && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please fill in the Company name
                </span>
              )}
            </FormGroup>
          </Card>
          <Card>
            <FormGroup>
              <Label>
                Meeting From
                {fieldData?.meetingOnField && <Asterisk> *</Asterisk>}
              </Label>
              <StyledDatePicker
                selected={formData.meetingOn}
                onChange={(date) =>
                  setFormData((prevData) => ({ ...prevData, meetingOn: date }))
                }
                showTimeSelect
                dateFormat="Pp"
                disabled={!fieldDataLoaded || fieldData?.meetingOnField} // Disable input based on condition
              />
            </FormGroup>
            <FormGroup>
              <Label>
                Meeting To{fieldData?.meetingToField && <Asterisk> *</Asterisk>}
              </Label>
              <StyledDatePicker
                selected={formData.meetingTo}
                onChange={(date) =>
                  setFormData((prevData) => ({ ...prevData, meetingTo: date }))
                }
                showTimeSelect
                dateFormat="Pp"
                disabled={!fieldDataLoaded || fieldData?.meetingToField} // Disable input based on condition
              />
            </FormGroup>

            <FormGroup>
              <Label>
                Id Proof Type
                {fieldData?.idProofTypeField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="idProofId"
                value={formData.idProofId}
                onChange={handleChange}
                disabled={!fieldDataLoaded || fieldData?.idProofTypeField} // Disable input based on condition
              >
                <option value="">Select ID Proof Type</option>
                {idProofTypes.map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.idProofDescription}
                  </option>
                ))}
              </Select>
              {formErrors.idProofId && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a Id Prood type
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Id Proof Number
                {fieldData?.idProofNumberField && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="text"
                name="visitorIdNumber"
                maxLength={4}
                value={formData.visitorIdNumber}
                onChange={handleChange}
                placeholder="Enter Id Proof Number"
                style={{
                  borderColor: formErrors.visitorIdNumber ? "red" : "2B3497",
                }}
                disabled={!fieldDataLoaded || fieldData?.idProofNumberField} // Disable input based on condition
              />
              {formErrors.visitorIdNumber && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please Fill the Id Proof Number
                </span>
              )}
              {/* <input
                type="text"
                name="visitorIdNumber"
                placeholder="Enter Id Proof Number"
                value={formData.visitorIdNumber}
                onChange={(e) => {
                  const value = e.target.value;
                  const regex = /^[a-zA-Z0-9]*$/;
                  if (value === '' || regex.test(value)) {
                    handleInputChange(e);
                  }
                }}
                style={{ border: '1px solid black', padding: '5px', width: '100%' }}
              />
              {formErrors.visitorIdNumber && (
                <span style={{ color: 'red', fontSize: '12px' }}>
                  Please Fill the Id Proof Number
                </span>
              )} */}
            </FormGroup>
            <FormGroup>
              <Label>
                Host Name<Asterisk> *</Asterisk>
              </Label>
              <Input
                type="text"
                name="hostname"
                value={empName}
                placeholder="Enter Host name"
                onChange={handleInputChange}
                disabled={true} // Disable input based on condition
              />
            </FormGroup>
            <FormGroup>
              <Label>Vehicle No</Label>
              <Input
                type="text"
                name="vehicleno"
                placeholder="Enter Vehicle No"
                value={formData.vehicleno}
                onChange={handleInputChange}
              />
            </FormGroup>
          </Card>
          <ProfileCard>
            <VisitorPhotoHeading>Visitor Photo</VisitorPhotoHeading>
            <ProfileText>(Only JPEG and PNG Images)</ProfileText>
            <Circle>
              <WebcamContainer>
                {isCameraOn && (
                  <Webcam
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                    width="100%"
                    height="100%"
                    videoConstraints={{
                      width: 200,
                      height: 200,
                      facingMode: "user",
                    }}
                  />
                )}
                {!isCameraOn && profileImage && (
                  <img
                    src={profileImage}
                    alt="Profile"
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                    }}
                  />
                )}
                {!isCameraOn && !profileImage && (
                  <ProfileIcon>
                    <User size={40} />
                  </ProfileIcon>
                )}
              </WebcamContainer>
            </Circle>

            <ButtonRow>
              <PhotoButton onClick={handleCapture}>{buttonLabel}</PhotoButton>
            </ButtonRow>

            <ButtonRow>
              <ActionButton onChange={handleImageUpload}>
                <label htmlFor="upload-button" style={{ cursor: "pointer" }}>
                  Upload Image
                </label>
              </ActionButton>
            </ButtonRow>
            <input
              id="upload-button"
              ref={fileInputRef} // ✅ connect the ref
              type="file"
              accept="image/png, image/jpeg"
              style={{ display: "none" }}
              onChange={handleImageUpload}
            />

            <CheckboxContainer>
              <input
                type="checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              <span>
                I agree to the
                <PrivacyLink onClick={handlePrivacyLinkClick}>
                  Privacy Policy
                </PrivacyLink>
              </span>
            </CheckboxContainer>
            {isPopupVisible && (
              <PopupOverlay>
                <PopupContent>
                  <h3>Privacy Policy</h3>
                  {entity?.privacyPolicy ? (
                    <div>{entity?.privacyPolicy}</div>
                  ) : (
                    <>
                      <p>
                        While visiting facilities ("Facilities"), the visitor
                        may have access to or receive some information that is
                        secret or proprietary to Fidrox (collectively ‘Company’)
                        concerning their business or technology. The visitor
                        undertakes to adhere by the rules of this Agreement
                        respecting the confidentiality of any Confidential
                        Information to which he or she has access or receives.
                      </p>
                      <p>
                        “Confidential Information”: for purpose of this
                        Agreement shall mean and include, any and all
                        information in written, electronic, verbal or other form
                        relating directly or indirectly to the present or
                        potential business, operation or financial condition of
                        or relating including, but not limited to, information
                        pertaining to pricing, marketing plans or strategy,
                        volumes, services rendered, customers and suppliers
                        lists, financial or technical or service matters or
                        data, trade secrets, designs, programming codes,
                        personal or sensitive data of any related parties,
                        intellectual property, and any information which might
                        reasonably be presumed to be proprietary or confidential
                        in nature and also includes all information identified
                        by Company as confidential.
                      </p>
                      <p>I agree that:</p>
                      <ul>
                        <li>
                          I have access to confidential information, I shall not
                          release, publish, or disclose such information to
                          unauthorized personnel. I shall protect such
                          information and will employ all reasonable efforts to
                          maintain the confidentiality of such information.
                        </li>
                        <li>
                          I shall immediately notify the Company-security
                          personnel of any suspected or confirmed unauthorized
                          disclosure and/or misuse of confidential information.
                        </li>
                        <li>
                          I shall not make any sound recordings, take any
                          photographs or make any movies, copies or reproductive
                          images (in any medium) of anything at the facility
                          (ies); Upon Company’s request, I shall promptly return
                          all Confidential Information received from Company
                          together with all copies, or certify in writing that
                          all such Confidential Information and copies thereof
                          have been destroyed.
                        </li>
                        <li>
                          While entering Company data center, I consent for my
                          personal body and my belongings (baggage, luggage,
                          electronic gadgets, etc.) for security frisking
                          purposes.
                        </li>
                        <li>
                          Company may collect certain personal information with
                          relation to the purpose of this agreement that is
                          visiting data center(s). I acknowledge it in detail at{" "}
                          <a
                            href="https://www.fidrox.com/privacy-policy/"
                            target="_blank"
                          >
                            https://www.fidrox.com/privacy-policy/
                          </a>
                          .
                        </li>
                        <li>
                          This Agreement shall remain in effect until such time
                          as all Confidential Information of Company disclosed
                          hereunder becomes publicly known without my action or
                          inaction.
                        </li>
                      </ul>
                    </>
                  )}
                  {/* <CheckboxContainer>
                    <input type="checkbox" checked={isChecked} onChange={handleCheckboxChange} />
                    <span>
                      I agree to the

                    </span>
                  </CheckboxContainer> */}
                  <ButtonContainer>
                    <CloseButton onClick={handleClosePopup}>Close</CloseButton>
                  </ButtonContainer>
                </PopupContent>
              </PopupOverlay>
            )}
          </ProfileCard>
        </CardContainer>
      </TabContent>

      <TabContent active={activeTab === "acknowledge"}>
        <CardContainer>
          <Card>
            {(entity?.uploadTrainingVideos && entity?.trainingVideosLink) ||
            (entity?.uploadSafetyGuidelinesDocuments &&
              (entity?.safetyGuidelines?.safetyGuidelinesDocumentLink ||
                entity?.safetyGuidelines?.safetyGuidelinesVideoLink)) ||
            entity?.ndaDocument ? (
              <>
                {/* Training Videos */}
                {entity?.uploadTrainingVideos && entity?.trainingVideosLink && (
                  <AckItem>
                    {/* Checkbox only controls state */}
                    <input
                      type="checkbox"
                      id="training"
                      checked={ackChecklist?.training || false}
                      onChange={(e) =>
                        setAckChecklist({
                          ...ackChecklist,
                          training: e.target.checked,
                        })
                      }
                    />

                    <AckText>
                      I acknowledge I have watched the{" "}
                      <span
                        style={{
                          color: "#293495",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.preventDefault(); // prevent checkbox toggle when clicking link
                          setVideoUrl(entity.trainingVideosLink);
                          setOpenVideoModal(true);
                        }}
                      >
                        Training Video
                      </span>
                    </AckText>
                  </AckItem>
                )}

                {/* Safety Guidelines Document */}
                {entity?.uploadSafetyGuidelinesDocuments &&
                  entity?.safetyGuidelines?.safetyGuidelinesDocumentLink && (
                    <AckItem htmlFor="safetyDoc">
                      <input
                        type="checkbox"
                        id="safetyDoc"
                        checked={ackChecklist?.safetyDoc || false}
                        onChange={(e) =>
                          setAckChecklist({
                            ...ackChecklist,
                            safetyDoc: e.target.checked,
                          })
                        }
                      />
                      <AckText>
                        I acknowledge I have read the{" "}
                        <span
                          style={{
                            color: "#293495",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.preventDefault(); // don't let it trigger link behavior
                            setShowPdfModal(true);
                          }}
                          href={
                            entity.safetyGuidelines.safetyGuidelinesDocumentLink
                          }
                          target="_self"
                          rel="noopener noreferrer"
                        >
                          Safety Guidelines Document
                        </span>
                      </AckText>
                    </AckItem>
                  )}

                {/* Safety Guidelines Video */}
                {entity?.uploadSafetyGuidelinesDocuments &&
                  entity?.safetyGuidelines?.safetyGuidelinesVideoLink && (
                    <AckItem>
                      {/* Checkbox only controls state */}
                      <input
                        type="checkbox"
                        id="safetyVideo"
                        checked={ackChecklist.safetyVideo || false}
                        onChange={(e) =>
                          setAckChecklist({
                            ...ackChecklist,
                            safetyVideo: e.target.checked,
                          })
                        }
                      />

                      <AckText>
                        I acknowledge I have watched the{" "}
                        <span
                          style={{
                            color: "#293495",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.preventDefault(); // don't let it trigger link behavior
                            setVideoUrl(
                              entity?.safetyGuidelines
                                ?.safetyGuidelinesVideoLink,
                            );
                            setOpenVideoModal(true);
                          }}
                        >
                          Safety Guidelines Video
                        </span>
                      </AckText>
                    </AckItem>
                  )}
                {entity?.ndaDocument && (
                  <AckItem>
                    <input
                      type="checkbox"
                      id="ndaDoc"
                      checked={ackChecklist.ndaDoc || false}
                      style={{ cursor: "not-allowed" }}
                      // disabled
                      // onChange={(e) =>
                      //   setAckChecklist({
                      //     ...ackChecklist,
                      //     ndaDoc: e.target.checked,
                      //   })
                      // }
                    />
                    <AckText>
                      I acknowledge I have read the{" "}
                      <span
                        style={{
                          color: "#293495",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={async (e) => {
                          e.preventDefault();
                          setLoading(true);
                          try {
                            const requestData = {
                              idProofNumber: formData?.visitorIdNumber,
                              hostID: parseInt(formData?.employeeId),
                              visitorName:
                                formData?.firstName +
                                (formData?.middleName != null
                                  ? " " + formData.middleName
                                  : "") +
                                " " +
                                formData?.lastName,
                              visitorMobile: formData?.visitorMobile,
                              visitorCompany: formData?.visitorCompany,
                              nationalityCode: formData?.nationality,
                              ndadDocumentToken: "",
                              iAccpect: true,
                              checkInDateTime: new Date(),
                              VisitorType: String(formData?.visitorType),
                            };

                            const response = await axiosInstance.post(
                              "/Entity/GetNDADocumentByVisitorDetails",
                              [requestData]
                            );

                            if (response.data && response.data.length > 0) {
                              const ndaPath = response.data[0].NDADocumentPath;

                              const fileResponse = await axiosInstance.get(
                                `/document/Documentdownload?token=${encodeURIComponent(ndaPath)}`,
                                { responseType: "blob" }
                              );

                              const pdfBlobUrl = window.URL.createObjectURL(
                                new Blob([fileResponse.data], { type: "application/pdf" })
                              );

                              setPdfUrl(pdfBlobUrl);
                              setSelectedRowId(entity.id);
                              setOpenPdfModal(true); // ✅ Open PDF modal directly
                            } else {
                              toast.error("No NDA document found.");
                            }
                          } catch (error) {
                            console.error("Error fetching NDA document:", error);
                            toast.error("Failed to fetch the NDA document.");
                          } finally {
                            setLoading(false);
                          }
                        }}
                      >
                        NDA Document
                      </span>
                    </AckText>
                  </AckItem>
                )}
                {/* {ackChecklist.ndaDoc && (
                <FormGroup>
                  <Label>
                    NDA Document
                  </Label>

                  <FileUploadContainer>
                    <CustomFileButton
                      onClick={() =>
                        document.getElementById("transportVendorFileInput").click()
                      }
                    >
                      Choose File
                    </CustomFileButton>

                    <FileNameInput
                      type="text"
                      value={transportVendorFileName || ""}
                      placeholder="No file chosen"
                      readOnly
                    />

                    <HiddenFileInput
                      id="transportVendorFileInput"
                      type="file"
                      accept=".pdf,.doc,.docx"
                      onChange={async (e) => {
                        const file = e.target.files[0];
                        if (file) {
                          setTransportVendorFileName(file.name);

                          try {
                            const base64String = await fileToBase64(file);
                            setTransportVendorFileBase64(base64String); // store base64 string
                          } catch (err) {
                            console.error("File conversion error:", err);
                          }
                        }
                      }}
                    />
                  </FileUploadContainer>
                </FormGroup>
              )} */}
              </>
            ) : (
              <div
                style={{
                  textAlign: "center",
                  padding: "2rem",
                  color: "#555",
                  fontSize: "1rem",
                }}
              >
                No acknowledgment materials are available at the moment.
              </div>
            )}
          </Card>
          {openPdfModal && (
            <PdfModalOverlay>
              <PdfModalContent>
                <CloseButtonIcon onClick={() => setOpenPdfModal(false)}>
                  ✖
                </CloseButtonIcon>
                <PdfFrame src={pdfUrl} title="NDA Document" />

                {/* Bottom action row */}
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "15px" }}>
                  <AgreeButton
                    onClick={() => {
                      setShowSignatureModal(true);
                    }}
                  >
                    I Agree
                  </AgreeButton>

                </div>
              </PdfModalContent>
            </PdfModalOverlay>
          )}

          {showSignatureModal && (
            <PdfModalOverlay>
              <PdfModalContent style={{ maxWidth: "500px" }}>
                <CloseButtonIcon onClick={() => {
                  setShowSignatureModal(false);
                  if (sigCanvasRef.current) sigCanvasRef.current.clear();
                }}>
                  ✖
                </CloseButtonIcon>

                <h3 style={{ marginBottom: "10px", color: "#293495" }}>
                  Your Signature
                </h3>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "12px" }}>
                  Please sign below to apply your signature to the NDA Document.
                </p>

                {/* Signature Canvas */}
                <div style={{
                  border: "1px solid #2b3497",
                  borderRadius: "8px",
                  overflow: "hidden",
                  marginBottom: "12px",
                  background: "#f9f9f9"
                }}>
                  <SignatureCanvas
                    ref={sigCanvasRef}
                    penColor="black"
                    canvasProps={{
                      width: 450,
                      height: 200,
                      style: { display: "block" }
                    }}
                  />
                </div>

                {/* Clear + Confirm buttons */}
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <button
                    onClick={() => sigCanvasRef.current?.clear()}
                    style={{
                      padding: "8px 16px",
                      border: "2px solid #293495",
                      borderRadius: "6px",
                      background: "transparent",
                      color: "#293495",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                  >
                    Clear
                  </button>

                  <button
                    style={{
                      padding: "8px 16px",
                      background: "#293495",
                      color: "#fff",
                      border: "none",
                      borderRadius: "6px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = "#1f276f"}
                    onMouseLeave={(e) => e.currentTarget.style.background = "#293495"}
                    onClick={async () => {
                        // 1. Capture signature only if user has drawn something
                        const isSigned = sigCanvasRef.current && !sigCanvasRef.current.isEmpty();
                        const signatureDataURL = isSigned
                          ? sigCanvasRef.current.getCanvas().toDataURL("image/png")
                          : null;

                        // 2. Close signature modal
                        setNDASignature(signatureDataURL); // store signature data URL in state
                        setShowSignatureModal(false);
                        if (sigCanvasRef.current) sigCanvasRef.current.clear();

                        // 3. If no signature, skip API call — just mark agreed and close PDF modal
                        if (!isSigned) {
                          setAckChecklist((prev) => ({ ...prev, ndaDoc: true }));
                          setOpenPdfModal(false);
                          toast.success("You agreed to the NDA.");
                          return;
                        }

                        // 4. Signature provided — call API with NDASignature, update PDF
                        setLoading(true);
                        try {
                          const requestData = {
                            idProofNumber: formData?.visitorIdNumber,
                            hostID: parseInt(formData?.employeeId),
                            visitorName:
                              formData?.firstName +
                              (formData?.middleName != null ? " " + formData.middleName : "") +
                              " " +
                              formData?.lastName,
                            visitorMobile: formData?.visitorMobile,
                            visitorCompany: formData?.visitorCompany,
                            nationalityCode: formData?.nationality,
                            ndadDocumentToken: "",
                            iAccpect: true,
                            checkInDateTime: new Date(),
                            VisitorType: String(formData?.visitorType),
                            NDASignature: signatureDataURL, // ✅ base64 signature
                          };

                          const response = await axiosInstance.post(
                            "/Entity/GetNDADocumentByVisitorDetails",
                            [requestData]
                          );

                          if (response.data && response.data.length > 0) {
                            const ndaPath = response.data[0].NDADocumentPath;

                            const fileResponse = await axiosInstance.get(
                              `/document/Documentdownload?token=${encodeURIComponent(ndaPath)}`,
                              { responseType: "blob" }
                            );

                            const updatedPdfBlobUrl = window.URL.createObjectURL(
                              new Blob([fileResponse.data], { type: "application/pdf" })
                            );

                            // 5. Update PDF, mark agreed, close PDF modal
                            setPdfUrl(updatedPdfBlobUrl);
                            setAckChecklist((prev) => ({ ...prev, ndaDoc: true }));
                            setOpenPdfModal(false);
                            toast.success("You agreed to the NDA.");
                          } else {
                            toast.error("No NDA document found.");
                          }
                        } catch (error) {
                          console.error("Error applying signature:", error);
                          toast.error("Failed to apply signature.");
                        } finally {
                          setLoading(false);
                        }
                      }}
                  >
                    Confirm
                  </button>
                </div>
              </PdfModalContent>
            </PdfModalOverlay>
          )}

          {openVideoModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                background: "rgba(0,0,0,0.7)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 2000, // ensure above everything
              }}
            >
              <div
                style={{
                  position: "relative",
                  width: "80%",
                  maxWidth: "900px",
                  background: "#000",
                  borderRadius: "10px",
                  overflow: "hidden",
                }}
              >
                {/* Close button */}
                <button
                  onClick={() => {
                    setOpenVideoModal(false);
                    setVideoUrl(""); // clear video when closing
                  }}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    fontSize: "22px",
                    background: "transparent",
                    border: "none",
                    color: "#fff",
                    cursor: "pointer",
                    zIndex: 2100,
                  }}
                >
                  ✖
                </button>

                {/* Video Player */}
                {videoUrl.includes("youtube.com") ||
                videoUrl.includes("youtu.be") ? (
                  <iframe
                    width="100%"
                    height="500"
                    src={
                      videoUrl.includes("watch?v=")
                        ? videoUrl.replace("watch?v=", "embed/")
                        : videoUrl.replace("youtu.be/", "youtube.com/embed/")
                    }
                    title="Training Video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                ) : (
                  <video width="100%" height="500" controls autoPlay>
                    <source src={videoUrl} type="video/mp4" />
                    Your browser does not support HTML5 video.
                  </video>
                )}
              </div>
            </div>
          )}
        </CardContainer>
        {showPdfModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.7)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2000, // ensure above everything
              cursor: "pointer",
            }}
            onClick={() => setShowPdfModal(false)}
          >
            <div
              style={{
                position: "relative",
                width: "80%",
                maxWidth: "1120px",
                height: "80%",
                background: "#000",
                borderRadius: "10px",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  right: 0,
                  top: 0,
                }}
              >
                S
                <CloseButton onClick={() => setShowPdfModal(false)}>
                  ✖
                </CloseButton>
              </div>
              <iframe
                src={entity?.safetyGuidelines?.safetyGuidelinesDocumentLink}
                width="100%"
                height="100%"
                title="Safety Guidelines"
              />
            </div>
          </div>
        )}
      </TabContent>
      <ToastContainer />
    </Container>
  );
};

export default VisitorApplication;
